import {
	Box,
	Button,
	Divider,
	Paper,
	Skeleton,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	Typography,
} from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PAGE_SIZE } from 'services/constants/env';
// import { PaginationBlock } from './PaginationBlock';
// import { FilterPanel } from './FilterPanel';
// import { ShipmentsTableHeader } from './ShipmentsTableHeader';
// import { ShipmentsRow } from './ShipmentsRow';
import { FilterPanel } from 'components/ErrorsCorrections/ErrorsTable/FilterPanel';
import {
	getSwissPostAvailableEmsRequest,
	getSwissPostConnectedEmsRequest,
	createSwissPostRequest,
} from 'redux/reducers/swissPost/reducer';
import {
	getSwissPostConnectedEms,
	getSwissPostConnectedEmsIsLoad,
} from 'redux/reducers/swissPost/selectors';
import { PaginationBlock } from 'ui/PaginationBlock';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { EasTable } from 'ui/EasTable';
import { EasTableFilterPanel } from 'ui/EasTableFilterPanel';
import { TTableStructure } from 'ui/EasTable/types';
import { TSwissPostConnectedEms } from 'redux/reducers/swissPost/types';
import { shipmentsData } from './shipments-data';
import { ShipmentsTableHeader } from './ShipmentsTableHeader';
import { ShipmentsRow } from './ShipmentsRow';
import { shipmentsStructure } from './shipments-structure';
import { ConnectClientToSwissPost } from './ConnectClientToSwissPost';
import { EditClientDialog } from './ShipmentsRow/EditClientDialog';
import { ConnectClientDialog } from './ConnectClientToSwissPost/ConnectClientDialog';
import { ConfirmationDialog } from '../../ui/ConfirmationDialog';
import { EasTableWithFilter } from '../../ui/EasTableWithFilter';

const ROWS = Array.from(new Array(PAGE_SIZE / 2));

export const Shipments: FC = () => {
	const dispatch = useDispatch();
	const shipments = useSelector(getSwissPostConnectedEms);
	const { search } = useLocation();
	const location = useLocation();
	const navigateParams = queryString.parse(search);
	const { page } = queryString.parse(search);
	const shipmentsLoader = useSelector(getSwissPostConnectedEmsIsLoad);
	const [selectedId, setSelectedId] = useState<number | null>(null);

	useEffect(
		() => {
			dispatch(getSwissPostConnectedEmsRequest({ pageSize: PAGE_SIZE }));
			dispatch(getSwissPostAvailableEmsRequest());
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);

	useEffect(() => {
		dispatch(
			getSwissPostConnectedEmsRequest({
				pageNumber: page ? +page : 1,
				pageSize: PAGE_SIZE,
				searchString: String(navigateParams?.search ?? ''),
			}),
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, location.search]);

	const [selectedShipmentIndex, setSelectedShipmentIndex] = useState<number | null>(null);
	const [editClientDialogOpen, setEditClientDialogOpen] = useState(false);
	const [openDisableDialog, setOpenDisableDialog] = useState(false);
	const [openEnableDialog, setOpenEnableDialog] = useState(false);
	const handleDisableDialogClose = () => {
		setOpenDisableDialog(false);
		setSelectedShipmentIndex(null);
	};
	const handleEnableDialogClose = () => {
		setOpenEnableDialog(false);
		setSelectedShipmentIndex(null);
	};
	const handleEditClientDialogClose = () => {
		setEditClientDialogOpen(false);
		setSelectedShipmentIndex(null);
	};
	const handleEditClientDialogOpen = (shipment: TSwissPostConnectedEms) => {
		setEditClientDialogOpen(true);
		setSelectedShipmentIndex(
			shipments?.data.findIndex((item) => item.em_id === shipment.em_id) ?? null,
		);
	};

	const handleDisable = () => {
		const shipment = shipments?.data.find((item) => item.em_id === selectedId);
		console.log('shipment', shipment);
		console.log('selectedId', selectedId);
		if (!shipment) return;
		dispatch(
			createSwissPostRequest({
				body: {
					emId: shipment.em_id,
					msgProjectIdOss: shipment.msg_project_id_oss,
					msgProjectIdIoss: shipment.msg_project_id_ioss,
					city: shipment.shipper_city,
					address: shipment.shipper_address,
					countryIso2Code: shipment.shipper_country_iso_code,
					zipCode: shipment.shipper_zip_code,
					defaultHs6Code: shipment.default_hs6_code,
					frankingLicense: shipment.franking_license,
					swissFirstMileClientId: shipment.swiss_first_mile_client_id,
					swissFirstMileClientSecret: shipment.swiss_first_mile_client_secret,
					isEnabled: false,
				},
				request: {
					pageNumber: page ? +page : 1,
					pageSize: PAGE_SIZE,
					searchString: String(navigateParams?.search ?? ''),
				},
			}),
		);
		setOpenDisableDialog(false);
		setSelectedId(null);
	};

	const handleEnable = () => {
		const shipment = shipments?.data.find((item) => item.em_id === selectedId);
		if (!shipment) return;
		dispatch(
			createSwissPostRequest({
				body: {
					emId: shipment.em_id,
					msgProjectIdOss: +shipment.msg_project_id_oss,
					msgProjectIdIoss: shipment.msg_project_id_ioss,
					city: shipment.shipper_city,
					address: shipment.shipper_address,
					countryIso2Code: shipment.shipper_country_iso_code,
					zipCode: shipment.shipper_zip_code,
					defaultHs6Code: shipment.default_hs6_code,
					frankingLicense: shipment.franking_license,
					swissFirstMileClientId: shipment.swiss_first_mile_client_id,
					swissFirstMileClientSecret: shipment.swiss_first_mile_client_secret,
					isEnabled: true,
				},
				request: {
					pageNumber: page ? +page : 1,
					pageSize: PAGE_SIZE,
					searchString: String(navigateParams?.search ?? ''),
				},
			}),
		);
		setOpenEnableDialog(false);
		setSelectedId(null);
	};

	const handleEdit = (shipment: TSwissPostConnectedEms) => {
		handleEditClientDialogOpen(shipment);
	};

	const handleAction = (id: number, typeOfDialog: string) => {
		const shipment = shipments?.data.find((item) => item.em_id === id);
		if (shipment) {
			if (typeOfDialog === 'Edit') {
				handleEdit(shipment);
			}
			if (typeOfDialog === 'Enable') {
				// handleEnable(shipment);
				setSelectedId(shipment.em_id);
				setOpenEnableDialog(true);
			} else if (typeOfDialog === 'Disable') {
				// handleDisable(shipment);
				setSelectedId(shipment.em_id);
				setOpenDisableDialog(true);
			}
		}
	};

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<EasTableWithFilter<TSwissPostConnectedEms & { id: number }>
				tableStructure={shipmentsStructure as TTableStructure<keyof TSwissPostConnectedEms>[]}
				items={
					shipments
						? {
								data: shipments.data.map((item) => ({ ...item, id: item.em_id })),
								totalCount: shipments.totalCount,
								pageNumber: page ? +page : 1,
								pageSize: PAGE_SIZE,
							}
						: null
				}
				itemsIsLoading={shipmentsLoader}
				handleAction={handleAction}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="body1" color="primary" fontWeight="bold">
						SwissPost Connected Clients
					</Typography>
					<ConnectClientToSwissPost />
				</Box>
			</EasTableWithFilter>
			{!shipmentsLoader && !shipments?.data.length && (
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '620px',
						width: '100%',
						color: '#016196',
						fontSize: '24px',
						fontWeight: 'bold',
					}}
				>
					No clients found...
				</Box>
			)}
			<ConnectClientDialog
				open={editClientDialogOpen}
				setClose={handleEditClientDialogClose}
				data={selectedShipmentIndex !== null ? shipments?.data[selectedShipmentIndex] : undefined}
				isEdit
			/>
			<ConfirmationDialog
				open={openDisableDialog}
				setClose={() => setOpenDisableDialog(false)}
				handleConfirm={handleDisable}
				title="Confirmation"
				text="Are you sure you want to disable the client?"
			/>
			<ConfirmationDialog
				open={openEnableDialog}
				setClose={() => setOpenEnableDialog(false)}
				handleConfirm={handleEnable}
				title="Confirmation"
				text="Are you sure you want to enable the client?"
			/>
		</Box>
	);
};
